import { render, staticRenderFns } from "./WarningView.vue?vue&type=template&id=522780ff&scoped=true&"
import script from "./WarningView.vue?vue&type=script&lang=js&"
export * from "./WarningView.vue?vue&type=script&lang=js&"
import style0 from "./WarningView.vue?vue&type=style&index=0&id=522780ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522780ff",
  null
  
)

export default component.exports